var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5618 0.878555L8.18882 15.2401C8.18277 15.2621 8.16966 15.2815 8.1515 15.2954C8.13335 15.3092 8.11115 15.3167 8.08831 15.3167C8.06548 15.3167 8.04328 15.3092 8.02512 15.2954C8.00696 15.2815 7.99385 15.2621 7.9878 15.2401L6.20099 9.1128L0.0736942 7.30365C0.0516767 7.2976 0.0322541 7.28449 0.018411 7.26633C0.00456791 7.24818 -0.00292969 7.22597 -0.00292969 7.20314C-0.00292969 7.18031 0.00456791 7.15811 0.018411 7.13995C0.0322541 7.12179 0.0516767 7.10868 0.0736942 7.10263L14.4203 0.729654C14.4408 0.722032 14.4631 0.7206 14.4844 0.725536C14.5058 0.730471 14.5252 0.741556 14.5402 0.757415C14.5553 0.773275 14.5654 0.793209 14.5692 0.814745C14.573 0.83628 14.5705 0.858469 14.5618 0.878555Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowVector);
export default __webpack_public_path__ + "static/media/arrow-vector.0685e9759be76525b3c0408b14bc6db2.svg";
export { ForwardRef as ReactComponent };